module.exports = __webpack_public_path__ + "img/icone_malha_fina.33a4c80b.png";